// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__bto3a","buttons":"SendReceipts_buttons__3gdyV","email":"SendReceipts_email__1_gud","bookApptTitle":"SendReceipts_bookApptTitle__2ScZk"};